"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi;
const phoneRegex = /(?:\+?\d{1,3}[ \-\.]?)?(?:\(?\d{2,4}\)?[ \-\.]?)?\d{3,4}[ \-\.]?\d{3,4}/g;
const urlRegex = /\b(?:https?:\/\/)?(?:www\.)?[a-z0-9\-]+\.[a-z]{2,}(?:\/[^\s]*)?/i;
function hasEmailOrPhone(str) {
    return containsEmail(str) || containsPhone(str);
}
exports.hasEmailOrPhone = hasEmailOrPhone;
function containsEmail(str) {
    return emailRegex.test(str);
}
exports.containsEmail = containsEmail;
function containsPhone(str) {
    return phoneRegex.test(str);
}
exports.containsPhone = containsPhone;
function containsLink(text, excludeInternal = false) {
    const internalDomain = 'anchorrides.com';
    let match;
    while ((match = urlRegex.exec(text)) !== null) {
        const domain = match[1].toLowerCase();
        if (!excludeInternal || !domain.endsWith(internalDomain)) {
            return true;
        }
    }
    return false;
}
exports.containsLink = containsLink;
function asyncForEach(arr, callback) {
    return __awaiter(this, void 0, void 0, function* () {
        for (let index = 0; index < arr.length; index++) {
            yield callback(arr[index], index, arr);
        }
    });
}
exports.asyncForEach = asyncForEach;
function roundToNearestCent(total) {
    return Math.round(total * 100 + Number.EPSILON) / 100;
}
exports.roundToNearestCent = roundToNearestCent;
function getPossessiveName(name) {
    if (!name)
        return null;
    return name[name.length - 1] === 's' ? `${name}'` : `${name}'s`;
}
exports.getPossessiveName = getPossessiveName;
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
exports.capitalize = capitalize;
function buildQueryString(params) {
    const query = Object.entries(params)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    return `?${query}`;
}
exports.buildQueryString = buildQueryString;
function formatPhoneForTwilio(phoneNumber) {
    if (phoneNumber.includes('+')) {
        return phoneNumber;
    }
    else {
        return phoneNumber
            .replace('(', '+1')
            .replace(')', '')
            .replace('-', '')
            .replace(' ', '');
    }
}
exports.formatPhoneForTwilio = formatPhoneForTwilio;
